import * as SelectItemList from 'types/_general/SelectItemList';

export type Type = {
	display?: boolean;
	iconSvgUrl?: string | null;
	id: string;
	name: string;
	source?: string | null;
	title?: string;
};

export function create(): Type {
	return {
		id: '',
		name: '',
	};
}

export function mapFromString(all: SelectItemList.Type, saved: string): Type {
	return all.filter((x) => x.id === saved)[0];
}
